module.exports = __webpack_public_path__ + "static/media/newest.620e3cf1.jpg";